import Box from "@mui/material/Box";
import OptionButton from "./OptionButton";

const detailLabels: Record<string, string> = {
  charSimp: "Simplified",
  charTrad: "Traditional",
  pinyin: "Pinyin",
  meaning: "Meaning"
};

const DetailCheckboxes = ({
  detailsOptions,
  setDetailsOptions,
  side
}: {
  detailsOptions;
  setDetailsOptions;
  side: string;
}) => (
  <Box
    role="group"
    aria-label={`${side === "front" ? "Front" : "Back"} card details`}
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1
    }}>
    {Object.entries(detailsOptions[side]).map(([key, checked]) => (
      <OptionButton
        key={key}
        fullWidth
        selected={!!checked}
        ariaLabel={`${side === "front" ? "Front" : "Back"} ${detailLabels[key] ?? key}`}
        onClick={() =>
          setDetailsOptions({
            ...detailsOptions,
            [side]: { ...detailsOptions[side], [key]: !checked }
          })
        }>
        {detailLabels[key] ?? key}
      </OptionButton>
    ))}
  </Box>
);

export default DetailCheckboxes;
